module.exports = __webpack_public_path__ + "static/media/img-products-meet.245e3342.png";